import { Injectable } from '@angular/core';
import { LoginData } from '@public-up/interface';

@Injectable({
  providedIn: 'root'
})
export class AeStorageService {
  private isLocal = false;

  public getLocal(key: string): any {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  public getSession(key: string): any {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  public getStorage(key: string): any {
    return this.isLocal ? this.getLocal(key) : this.getSession(key);
  }

  public setLocal(key: string, data: any): void {
    return localStorage.setItem(key, JSON.stringify(data));
  }

  public setSession(key: string, data: any): void {
    return sessionStorage.setItem(key, JSON.stringify(data));
  }

  public setStorage(key: string, data: any): void {
    return this.isLocal ? this.setLocal(key, data) : this.setSession(key, data);
  }

  public removeLocal(key: string): void {
    return localStorage.removeItem(key);
  }

  public removeSession(key: string): void {
    return sessionStorage.removeItem(key);
  }

  public removeStorage(key: string): void {
    return this.isLocal ? this.removeLocal(key) : this.removeSession(key);
  }

  public removeAll(key: string): void {
    this.removeLocal(key);
    this.removeSession(key);
  }

  public changeStorage(isLocal: boolean): void {
    this.isLocal = isLocal;
  }

  public isLogged(): LoginData | null {
    let loginData: LoginData = this.getSession('ae-login');
    if (loginData && loginData.token) {
      this.changeStorage(false);
      return loginData;
    }
    loginData = this.getLocal('ae-login');
    if (loginData && loginData.token) {
      this.changeStorage(true);
      return loginData;
    }
    return null;
  }
}
